// Single source of truth for call-session status badges. A session can end
// "completed" without the media ever connecting (pro accepted, WebRTC failed):
// nobody talked and nothing was billed, so it must NOT read "Completata".
export interface CallStatusInfo {
  label: string;
  color: string;
}

const statusLabels: Record<string, CallStatusInfo> = {
  completed: { label: 'Completata', color: 'text-green-700 bg-green-50' },
  active: { label: 'In Corso', color: 'text-brand-teal bg-brand-teal-50' },
  paused: { label: 'In Pausa', color: 'text-brand-teal bg-brand-teal-50' },
  ringing: { label: 'Squillo', color: 'text-brand-teal bg-brand-teal-50' },
  missed: { label: 'Persa', color: 'text-yellow-700 bg-yellow-50' },
  rejected: { label: 'Rifiutata', color: 'text-red-700 bg-red-50' },
  cancelled: { label: 'Annullata', color: 'text-neutral-600 bg-neutral-100' },
  failed: { label: 'Errore', color: 'text-red-700 bg-red-50' },
};

const notConnected: CallStatusInfo = { label: 'Non connessa', color: 'text-yellow-700 bg-yellow-50' };
const unknown = (status: string): CallStatusInfo => ({ label: status, color: 'text-neutral-600 bg-neutral-100' });

export function callStatusInfo(session: { status: string; connectedAt?: Date | string | null }): CallStatusInfo {
  if (session.status === 'completed' && !session.connectedAt) return notConnected;
  return statusLabels[session.status] ?? unknown(session.status);
}
